/**
 * deviceContext.js — Runtime detection utility for Match It Up
 * Determines whether the app is running as TWA, PWA, iOS Safari, Android Chrome, or Desktop.
 * Used to drive conditional CTAs, billing flows, and install prompts.
 */

const PACKAGE_NAME = 'in.matchitup.app';

/**
 * Returns the current shell context.
 * shell values: 'twa' | 'pwa-ios' | 'pwa-android' | 'pwa-desktop' | 'ios-safari' | 'ios-other-browser' | 'android-browser' | 'desktop'
 */
export function getDeviceContext() {
  const ua = navigator.userAgent;
  const isIOS = /iphone|ipad|ipod/i.test(ua);
  const isAndroid = /android/i.test(ua);
  const isTWA = document.referrer.includes('android-app://');
  const isStandalone =
    navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches;

  // Safari on iOS: has 'Safari' in UA, no 'CriOS' (Chrome) or 'FxiOS' (Firefox)
  const isIOSSafari = isIOS && /safari/i.test(ua) && !/crios|fxios|opios/i.test(ua);
  // Chrome/Firefox/Opera on iOS — can NOT install PWA
  const isIOSOtherBrowser = isIOS && !isIOSSafari;

  if (isTWA)                              return { shell: 'twa',                isIOS: false, isAndroid: true,  isStandalone: true };
  if (isStandalone && isIOS)             return { shell: 'pwa-ios',             isIOS: true,  isAndroid: false, isStandalone: true };
  if (isStandalone && isAndroid)         return { shell: 'pwa-android',         isIOS: false, isAndroid: true,  isStandalone: true };
  if (isStandalone)                      return { shell: 'pwa-desktop',         isIOS: false, isAndroid: false, isStandalone: true };
  if (isIOSOtherBrowser)                 return { shell: 'ios-other-browser',   isIOS: true,  isAndroid: false, isStandalone: false };
  if (isIOSSafari)                       return { shell: 'ios-safari',          isIOS: true,  isAndroid: false, isStandalone: false };
  if (isAndroid)                         return { shell: 'android-browser',     isIOS: false, isAndroid: true,  isStandalone: false };
  return                                        { shell: 'desktop',             isIOS: false, isAndroid: false, isStandalone: false };
}

/**
 * Check if the Match It Up Android app is already installed.
 * Uses navigator.getInstalledRelatedApps() — requires `related_applications` in manifest.json.
 * Returns false if API not supported or app not found.
 */
export async function checkIfAppInstalled() {
  if (!('getInstalledRelatedApps' in navigator)) return false;
  try {
    const apps = await navigator.getInstalledRelatedApps();
    return apps.some((app) => app.id === PACKAGE_NAME);
  } catch {
    return false;
  }
}
